export const GET_USERINFO = 'GET_USERINFO'
export const RECORD_USERINFO = 'RECORD_USERINFO'
export const DISPLAYHIDING_LOGININFO = 'DISPLAYHIDING_LOGININFO'
export const RECORD_STATE = 'RECORD_STATE'
export const REMOVE_USERINFO = 'REMOVE_USERINFO'
export const DISPLAYHIDING_ACCOUNT = 'DISPLAYHIDING_ACCOUNT'
export const RESET_SDPHASE = 'RESET_SDPHASE'
export const CHANGE_LOADING = 'CHANGE_LOADING'
export const ADD_DELIVERY = 'ADD_DELIVERY'
export const EDIT_ORDER = 'EDIT_ORDER'
export const ADD_SEX = 'ADD_SEX'
export const ADD_CATEGORY = 'ADD_CATEGORY'
export const ADD_STYLE = 'ADD_STYLE'
export const ADD_FABRICSUPPLY = 'ADD_FABRICSUPPLY'
export const CHANGE_DESIGN = 'CHANGE_DESIGN'
export const CHANGE_DESIGNCOPY = 'CHANGE_DESIGNCOPY'
export const CHANGE_DEFAULTFABRIC = 'CHANGE_DEFAULTFABRIC'
export const CONTENT_AREA = 'CONTENT_AREA'
export const CONTENT_FLAG = "CONTENT_FLAG"
export const DRAWER_NAME = "DRAWER_NAME"
export const ADD_SAVEUSERDATA = 'ADD_SAVEUSERDATA'
export const ADD_SDPHASETYPE = 'ADD_SDPHASETYPE'
export const ADD_SELFMASSING = 'ADD_SELFMASSING'
export const ADD_SELFDETERMINATION = 'ADD_SELFDETERMINATION'
export const CHANGE_WD_DESIGN = 'CHANGE_WD_DESIGN'
export const ADD_WD_FABRICSUPPLY = 'ADD_WD_FABRICSUPPLY'
export const ADD_GOODS = 'ADD_GOODS'
export const RECORD_WD_STATE = 'RECORD_WD_STATE'
export const CHANGE_LANG = 'CHANGE_LANG'
export const CHANGE_3D = 'CHANGE_3D'
export const ALL_MSG = 'ALL_MSG'
export const GD_END = 'GD_END'
export const GD_INFO = 'GD_INFO'
export const GD_RELATION = 'GD_RELATION'
export const CHANGE_IMG = 'CHANGE_IMG'
export const GLOBAL_FLAG = 'GLOBAL_FLAG'
export const CONTENT_DESIGN = 'CONTENT_DESIGN'
export const EDIT_COMMODITY = 'EDIT_COMMODITY'
export const ADD_EDITIONTYPE = 'ADD_EDITIONTYPE'
export const ADD_PROCESSLIST = 'ADD_PROCESSLIST'
export const CLEAR_CACHETDCIDS = 'CLEAR_CACHETDCIDS'
export const IS_STEP = 'IS_STEP'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js